// export const InformationMap = {
//   gender: '性别',
//   age: '年龄',
//   degree: '学历',
//   city: '城市',
//   career: '职业',
//   income: '收入',
//   interest: '爱好',
//   marital_status: '婚姻状态',
//   family_members: '家庭成员数',
//   personality: '性格',
//   faith: '信仰',
//   real_name: '姓名',
//   phone: '手机号',
//   email: '邮箱',
//   sport: '运动',
//   book: '书籍',
//   movie: '电影',
//   music: '音乐',
//   star: '明星',
//   interest_city: '喜欢的城市',
//   interest_country: '喜欢的国家',
//   color: '喜欢的颜色',
//   season: '季节',
//   plant: '植物',
//   animal: '动物',
// }

export const InformationList = [
  [
    {
      required: true,
      key: 'gender',
      options: [],
      type: 'select',
    },
    {
      required: true,
      options: [],
      key: 'age',
      type: 'select',
    },
    {
      required: true,
      options: [],
      key: 'degree',
      type: 'select',
    },
    {
      required: true,
      options: [],
      key: 'city',
      type: 'select',
      other: true,
    },
  ],

  [
    {
      required: true,
      options: [],
      key: 'career',
      type: 'select',
      other: true,
    },
    {
      required: true,
      options: [],
      key: 'income',
      type: 'select',
    },
    {
      required: true,
      options: [],
      key: 'interest',
      type: 'select',
      other: true,
    },
  ],
  [
    {
      required: true,
      options: [],
      key: 'marital_status',
      type: 'select',
    },
    {
      required: true,
      options: [],
      key: 'family_members',
      type: 'select',
    },
    {
      required: true,
      options: [],
      key: 'personality',
      type: 'select',
    },
    {
      required: true,
      options: [],
      key: 'faith',
      type: 'select',
      other: true,
    },
  ],
  [
    {
      required: true,
      key: 'real_name',
      type: 'input',
    },
    {
      required: true,
      key: 'phone',
      type: 'input',
    },
    {
      required: true,
      key: 'email',
      type: 'input',
    },
  ],
  [
    {
      required: true,
      key: 'sport',
      type: 'input',
    },
    {
      required: true,
      key: 'book',
      type: 'input',
    },
    {
      required: true,
      key: 'movie',
      type: 'input',
    },
  ],

  [
    {
      required: true,
      key: 'interest_country',
      type: 'input',
    },
    {
      required: true,
      key: 'interest_city',
      type: 'input',
    },
    {
      required: true,
      key: 'music',
      type: 'input',
    },
    {
      required: true,
      key: 'star',
      type: 'input',
    },
  ],
  [
    {
      required: true,
      key: 'color',
      type: 'input',
    },
    {
      required: true,
      key: 'season',
      type: 'input',
    },
    {
      required: true,
      key: 'plant',
      type: 'input',
    },
    {
      required: true,
      key: 'animal',
      type: 'input',
    },
  ],
]

// 判断key属于哪个type
export const getInformationType = (key: string) => {
  let type: 'select' | 'input' = 'select'
  InformationList.forEach((item) => {
    item.forEach((info) => {
      if (info.key === key) {
        type = info.type as 'select' | 'input'
      }
    })
  })
  return type as 'select' | 'input'
}

export const getInformationItem = (key: string) => {
  let item = {} as any
  InformationList.forEach((list) => {
    list.forEach((info) => {
      if (info.key === key) {
        item = info
      }
    })
  })
  return item
}
